<div class="app-layout" [class.sidebar-mini]="sidebarCollapsed">
  <!-- Fixed glass backdrop (orbs) — sits below all content (spec §3) -->
  <app-glass-background></app-glass-background>

  <!-- Mobile overlay -->
  <div
    class="sidebar-overlay"
    [class.active]="sidebarOpen"
    (click)="closeOverlay()"
  ></div>

  <app-sidebar></app-sidebar>

  <div class="main-content">
    <div class="content-area">
      <div class="content-inner">
        <!-- Owner directive: no dedicated top band. The header (toolbar +
             breadcrumb/H1) is the FIRST LINE OF THE BODY — it lives inside the
             content column and scrolls with it, not as a region above it. -->
        <app-header></app-header>
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

  <app-bottom-nav></app-bottom-nav>
</div>
